import { JSONSchema7 } from 'json-schema';
import * as yup from 'yup';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';

export default (
  control: ControlState
): {
  [key: string]: yup.AnySchema;
} => {
  const properties = control.schema?.properties as JSONSchema7Properties;
  const labelSchema = properties['label'] as JSONSchema7;
  const requiredSchema = properties['required'] as JSONSchema7;

  let controlYupSchema: yup.StringSchema = yup.string();

  if (!control.visible) {
    return {
      [control.id]: controlYupSchema
    };
  }

  if (requiredSchema && requiredSchema.default) {
    controlYupSchema = controlYupSchema.required(
      `${labelSchema.default} is required`
    );
  }

  controlYupSchema = controlYupSchema.test(
    'isValidTimeFormat',
    'Invalid time format',
    (time) => {
      if (!time) return true;

      return time.match(/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/) !== null;
    }
  );

  return {
    [control.id]: controlYupSchema
  };
};
